//UI state

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  showIntroModal: boolean;
  showChatbot: boolean;
  showTreeBubbles: boolean;
  showUserBubbles: boolean;
  currentSlide: number;
  isLoading: boolean;
  error: string | null;
  notification: {
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
  } | null;
}

const initialState: UIState = {
  showIntroModal: false,
  showChatbot: false,
  showTreeBubbles: true,
  showUserBubbles: false,
  currentSlide: 0,
  isLoading: false,
  error: null,
  notification: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setShowIntroModal: (state, action: PayloadAction<boolean>) => {
      state.showIntroModal = action.payload;
    },
    setShowChatbot: (state, action: PayloadAction<boolean>) => {
      state.showChatbot = action.payload;
    },
    setShowTreeBubbles: (state, action: PayloadAction<boolean>) => {
      state.showTreeBubbles = action.payload;
    },
    setShowUserBubbles: (state, action: PayloadAction<boolean>) => {
      state.showUserBubbles = action.payload;
    },
    setCurrentSlide: (state, action: PayloadAction<number>) => {
      state.currentSlide = action.payload;
    },
    nextSlide: (state) => {
      state.currentSlide += 1;
    },
    prevSlide: (state) => {
      if (state.currentSlide > 0) {
        state.currentSlide -= 1;
      }
    },
    resetSlides: (state) => {
      state.currentSlide = 0;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setNotification: (state, action: PayloadAction<UIState['notification']>) => {
      state.notification = action.payload;
    },
    clearNotification: (state) => {
      state.notification = null;
    },
  },
});

export const {
  setShowIntroModal,
  setShowChatbot,
  setShowTreeBubbles,
  setShowUserBubbles,
  setCurrentSlide,
  nextSlide,
  prevSlide,
  resetSlides,
  setLoading,
  setError,
  clearError,
  setNotification,
  clearNotification,
} = uiSlice.actions;

export default uiSlice.reducer;
